import moment from "moment";
import { TransactionType, TransactionTypeEnum } from "../constants/transaction";

export const getPathName = (): string => {
  return window.location.pathname;
};

export const formatCurrency = (value: number, isExpense?: boolean) =>
  `${isExpense ? "-" : "+"}$${Math.abs(value).toFixed(2)}`;

export const generateRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let hex = "#";
  for (let i = 0; i < 6; i++) {
    hex += letters[Math.floor(Math.random() * 16)];
  }
  return hex;
};

export const getLastSixMonths = () => {
  const months = [];
  for (let i = 5; i >= 0; i--) {
    months.push(moment().subtract(i, "months").format("MMM"));
  }
  return months;
};

export const getMonthlyTotal = (
  data: Array<TransactionType>,
  month: number,
  type: TransactionTypeEnum,
) => {
  return data
    .filter((item: TransactionType) => {
      const itemMonth = moment(item.date).format("M");
      return Number(itemMonth) === month && item.type === type;
    })
    .reduce((sum, item) => sum + item.amount, 0);
};
